import {
  FormControl,
  FormControlProps,
  FormLabel,
  HStack,
  Icon,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { MapMarkerAlt } from "@areahub/icons";
import { CustomOption, CustomSelect } from "@ui/application";

export interface BaseLocationSelectOption {
  id?: string;
  label?: string;

  nickname?: string | null;
}
export interface LocationSelectorProps<T extends BaseLocationSelectOption>
  extends Omit<FormControlProps, "id"> {
  title?: string;
  locations: T[];
  selected: T;
  setSelected: (location: T) => void;
}

export function LocationSelector<T extends BaseLocationSelectOption>({
  title,
  locations,
  selected,
  setSelected,
  ...props
}: LocationSelectorProps<T>) {
  const handleSelect = (id?: string | null) => {
    const location = locations.find((l) => l.id === id) as T;
    setSelected(location);
  };

  return (
    <FormControl id="user-location" {...props}>
      <FormLabel fontSize="xs">{title || "Your Locations"}</FormLabel>
      <CustomSelect
        name="UserLocation"
        colorScheme="blue"
        value={selected.id}
        onChange={handleSelect}
        placeholder="Select a location"
      >
        {locations.map((location) => (
          <CustomOption key={location?.id} value={location?.id as string}>
            <Tooltip
              label={location.label}
              shouldWrapChildren
              hasArrow
              placement="auto"
            >
              <HStack>
                <Icon as={MapMarkerAlt} />
                <Text>{location.nickname}</Text>
              </HStack>
            </Tooltip>
          </CustomOption>
        ))}
      </CustomSelect>
    </FormControl>
  );
}
